export const AUTH_MODAL_TABS = {
  LOGIN: 'login',
  SIGNUP: 'signup',
  FORGOT_PASSWORD: 'forgot-password'
}

export const AUTH_MODAL_STEPS = {
  EMAIL_VERIFICATION: 'email-verification',
  COMPLETE_FORM: 'complete-form'
}

export const PHONE_VERIFICATION_TYPE = {
  MILD: 'MILD',
  STRICT: 'STRICT'
}

// Allow unicode letters, accents, apostrophe, hyphen, period and space; blocks emojis, digits and other symbols.
// Mirrors the backend NAME_PATTERN (user/backend src/utils/constant.js) used for firstName/lastName validation.
export const NAME_REGEX = /^[\p{L}\p{M}'.\- ]+$/u

// Monitoring key for reset-password events
export const MONITORED_PASSWORD_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIzNDIyMzQiLCJuYW1lIjoiRGV2IHVzZXIiLCJlbWFpbCI6ImRldkBhbWdwbGF0Zm9ybS5jb20iLCJyb2xlIjoidXNlciIsImlhdCI6MTc4NTE5NjgwMCwiZXhwIjoyMDk5OTk5OTk5fQ.l7EI-5hkuLIH3hsdUEotc_laieTZEP7GdU6k48ej7W0'
